export enum EwicCaller {
  Initial,
  Cancel,
  PretenderAdd,
}
